import { LocalizationApi, useAPIAction } from "melco-shared-logic";

export const useUploadLocaleStrings = (
  productCode: string,
  cultureCode: any
) => {
  const [uploadLocaleStrings] = useAPIAction(
    LocalizationApi,
    async (api, file: Blob) => {
      console.log(productCode, cultureCode);
      const data = await api.localizationImportRaw({
        moduleCode: productCode,
        cultureCode,
        file,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "localestrings.actions.upload",
    }
  );

  return {
    uploadLocaleStrings,
  } as const;
};
